import type { SessionSnapshot } from '@sunucupark/client-core';
import { useCallback, useSyncExternalStore } from 'react';
import { useClient } from './client-context';

/**
 * The signed-in session, kept in sync with {@link AuthSession}: a refresh in
 * this tab or in another one re-renders whoever shows the account.
 */
export function useSession(): SessionSnapshot | null {
  const { session } = useClient();
  const subscribe = useCallback(
    (onChange: () => void) => session.subscribe(() => onChange()),
    [session],
  );
  const read = useCallback(() => session.snapshot(), [session]);
  return useSyncExternalStore(subscribe, read, read);
}

/** True while there is a session. */
export function useIsSignedIn(): boolean {
  return useSession() !== null;
}
